module.exports = __webpack_public_path__ + "img/stt-del-active.843f9a33.svg";